import React, { useEffect, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import UserRoles from '../../components/Config/Role/UserRoles';
import { Link } from 'react-router-dom';
import ConfigHome from '../../components/Config/ConfigHome';
import { useConfig } from '../../DataStore/ConfigContext';
import navItems from '../../components/Config/configItems';
import SystemUsers from '../../components/Config/User/SystemUsers';
import AlertDeleteUser from '../../components/Config/User/AlertDeleteUser';
import ClassLevels from '../../components/Config/ClassLevel/ClassLevels';
import Classes from '../../components/Config/Classes/Classes';
import AlertDeleteStream from '../../components/Config/Classes/AlertDeleteStream';
import Subjects from '../../components/Config/Subjects/Subjects';
import NewPaperModal from '../../components/Config/Subjects/NewPaperModal';
import AlertDeletePaper from '../../components/Config/Subjects/AlertDeletePaper';
import EditPaperModal from '../../components/Config/Subjects/EditPaperModal';
import NewUnitModal from '../../components/Config/Subjects/NewUnitModal';
import EditUnitModal from '../../components/Config/Subjects/EditUnitModal';
import AlertDeleteUnit from '../../components/Config/Subjects/AlertDeleteUnit';
import Terms from '../../components/Config/Term/Terms';
import Assessments from '../../components/Config/Exams/Assessments';
import CurrentPeriod from '../../components/Config/Exams/CurrentPeriod';
import Houses from '../../components/Config/House/Houses';
import SchoolProfile from '../../components/Config/Profile/SchoolProfile';
import ReportComment from '../../components/Config/Report/ReportComment';
import Permission from '../../components/Config/Role/Permission';
import PopAssignRolePermission from '../../components/Config/Role/PopAssignRolePermission';
import RolePermission from '../../components/Config/Role/RolePermission';
import AlertRevokePermission from '../../components/Config/Role/AlertRevokePermission';
import InterfaceConfig from '../../components/Config/ExternalInterface/InterfaceConfig';
import KeyConfig from '../../components/Config/Keys/KeyConfig';
import NewKeyModal from '../../components/Config/Keys/NewKeyModal';
import PopChangeUserRole from '../../components/Config/Role/PopChangeUserRole';

const ConfigPage = () => {
    const { activeMenu, dispatch } = useConfig();
    const [activeComponent, setActiveComponent] = useState(<ConfigHome />);
   
    useEffect(() => {
        setActiveComponent(renderActiveComponent(activeMenu));
    }, [activeMenu]);

    const renderActiveComponent = (menuId) => {
        const componentMapping = {
            1: <UserRoles />,
            2: <SystemUsers />,
            3: <Permission />,
            4: <SchoolProfile />,
            6: <ClassLevels />,
            7: <Classes />,
            8: <Terms />,
            10: <Assessments />,
            11: <CurrentPeriod />,
            12: <Subjects />,
            13: <Houses />,
            14: <ReportComment />,
            15: <RolePermission />,
            16: <InterfaceConfig />,
            17: <KeyConfig />,
        };
        return componentMapping[menuId] || <ConfigHome />;
    };

    const handleMenuClick = (id) => {
        dispatch({ type: 'activeMenu', payload: id });
    };

    return (
        <>
            <PageContainer>
                <MainContent>
                    <PageTitle
                        title="System Settings"
                        description="Configure your system settings and preferences"
                        iconClass="fa fa-cog"
                    />
                    {/* {currentNotify} */}
                    <div className="row small-gutters">
                        {/* Left Navigation Menu */}
                        <div className="col-md-3 mb-3">
                            <div className="card">
                                <div className="card-body p-0 overflow-auto" style={{ maxHeight: '600px' }}>
                                    <nav className="nav flex-column settings-nav">
                                        {navItems.map((item) => (
                                            <Link
                                                key={item.id}
                                                to={item.href}
                                                className={`nav-link ${item.id === activeMenu ? 'active' : ''}`}
                                                onClick={() => handleMenuClick(item.id)}
                                            >
                                                <i className={`${item.icon} me-2`}></i> {item.label}
                                            </Link>
                                        ))}
                                    </nav>
                                </div>
                            </div>
                        </div>

                        {/* Main Settings Form */}
                        <div className="col-md-9 overflow-auto" style={{ maxHeight: '600px' }}>
                            {activeComponent}
                        </div>
                    </div>
                </MainContent>
            </PageContainer>
            <AlertDeleteUser />
            <AlertDeleteStream />
            <NewPaperModal />
            <AlertDeletePaper />
            <EditPaperModal />
            <NewUnitModal />
            <EditUnitModal />
            <AlertDeleteUnit />
            <PopAssignRolePermission />
            <AlertRevokePermission />
            <NewKeyModal />
            <PopChangeUserRole />
        </>
    );
};

export default ConfigPage;
